import React,{useState} from "react";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

function MaidaFreeCakes() {
  const handleClickButton = (path) => {
    window.location.href = path;
  };
  const [activeKey, setActiveKey] = useState(null);
  const accordionData = [
    {
      title: "Are your cakes completely maida-free?",
      content: "Yes. All our cakes are made with 100% whole wheat flour and contain no maida.",
    },
    {
      title: "Do you use preservatives or artificial colours?",
      content: "No. We make natural and preservative-free cakes only.",
    },
    {
      title: "Are eggless options available?",
      content: "Yes. All cakes can be made eggless and vegetarian.",
    },
    {
      title: "Do you deliver in T. Nagar?",
      content: "Yes. We deliver maida-free cakes in T. Nagar and across Chennai.",
    },
    {
      title: "Can I choose brown sugar or jaggery?",
      content: "Yes. We offer brown sugar or jaggery cakes on request.",
    },
  ];

  return (
    <>
    <Helmet>
      <title>Maida Free Cake – Natural, Eggless & No-Maida Cakes Chennai</title>
      <meta
        name="description"
        content="Find answers about natural ingredient cakes, no-maida baking, healthy whole wheat treats & Chennai cake delivery."
      />
      <link rel="canonical" href="https://wheatbakes.com/maida-free-cakes" />
    </Helmet>
    
    <Container className="my-5">

      {/* PAGE HEADER */}
      <Row className="mb-4">
        <p className="text-align-center brown-text-color text-bold-600">
          MAIDA-FREE CAKES
        </p>
        <h1 className="text-align-center text-bold-600">
          Maida-Free Cakes — 100% Whole Wheat, No Preservatives
        </h1>
      </Row>

      {/* INTRO */}
      <Row className="align-items-center mb-5">
        <Col lg={6}>
          <p className="wheatbakes-para-justify">
            At WheatBakes, we specialise in <span className="fw-semibold">maida-free cakes</span> made with <span className="fw-semibold">100% whole
            wheat flour,</span> natural ingredients, and <span className="fw-semibold">zero preservatives.</span> If you are
            looking for healthier alternatives to traditional <span className="fw-semibold">maida cakes</span>, our
            cakes offer the perfect balance of taste, nutrition, and freshness.
          </p>
          <p className="wheatbakes-para-justify">
            Order <span className="fw-semibold">maida-free cakes online</span> and get fresh delivery across <span className="fw-semibold">Chennai,</span>
            including <span className="fw-semibold">T. Nagar.</span>
          </p>

          <div className="my-4">
            <button
              className="wheatbakes-btn"
              onClick={() => handleClickButton("https://wheatbakes.com/menu")}
            >
              Order Now
            </button>
          </div>
        </Col>
        <Col lg={6}>
          <img className="w-100" src="images/product/cakes2.jpg" alt="bakery" />
        </Col>
      </Row>

      {/* WHY MAIDA-FREE */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Why Choose Maida-Free Cakes Instead of Regular Maida Cakes?
        </h2>
        <p className="wheatbakes-para-justify">
          Refined flour (maida) lacks fibre and nutrients. That’s why our <span className="fw-semibold">healthy,
          whole wheat cakes</span> are crafted to give you better digestion, sustained
          energy, and guilt-free indulgence.
        </p>

        <Row className="g-4 mt-3">
          {[
            "100% whole wheat flour — no refined flour",
            "No preservatives bakery",
            "No added colours in cakes",
            "Naturally sweetened options",
            "Egg-less whole wheat cakes available",
            "Suitable for kids and health-conscious adults",
          ].map((item, idx) => (
            <Col md={4} key={idx}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <p className="mb-0">
                    <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span>
                    {item}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <br></br>
        <p>Our cakes are baked fresh daily using clean, simple recipes.</p>
      </section>

      {/* INGREDIENTS */}
      
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Made With Natural Ingredients Only
        </h2>
        <p className="wheatbakes-para-justify">
          Every maida-free cake at WheatBakes is prepared using <span className="fw-semibold">natural
          ingredients, following</span> a clean baking philosophy:
        </p>
        <ul>
          <li>Whole wheat flour</li>
          <li>Jaggery</li>
          <li>Fresh dairy ingredients</li>
          <li>Natural cocoa and fruit extracts</li>
          <li>No artificial flavours</li>
          <li>No preservatives</li>
        </ul>
        <p className="wheatbakes-para-justify">
          This ensures <span className="fw-semibold">natural, preservative-free cakes</span> that taste homemade and
          feel light.
        </p>
      </section>
      
      

      {/* CAKE COLLECTION */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Our Maida-Free Cake Collection
        </h2>
        <p>Choose from a variety of <span className="fw-semibold">maida-free cakes delivery</span> options:</p>
        <ul>
          <li>Whole Wheat Chocolate Cake</li>
          <li>Eggless Vanilla Whole Wheat Cake</li>
          <li>Brown Sugar Chocolate Cake</li>
          <li>Jaggery Sweetened Whole Wheat Cake</li>
          <li>Low Sugar Healthy Cakes</li>
          <li>Whole Wheat Brownies Delivery</li>
          <li>Wheat-Based Cookies and Pastries</li>
        </ul>

        <div className="my-4">
          <button
            className="wheatbakes-btn-light"
            onClick={() => handleClickButton("https://wheatbakes.com/menu")}
          >
            View Full Menu
          </button>
        </div>
      </section>

      {/* EGGLESS */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Eggless & Vegetarian Maida-Free Cakes
        </h2>
        <p className="wheatbakes-para-justify">
          We proudly offer <span className="fw-semibold">eggless whole wheat cakes and vegetarian cakes and desserts,</span>
          making WheatBakes ideal for families and celebrations.
        </p>
        <p>You can choose: </p>
        <ul>
          <li>Eggless recipes</li>
          <li>Custom sugar levels</li>
          <li>Portion sizes</li>
          <li>Birthday-friendly designs</li>
        </ul>
      </section>

      {/* OCCASIONS */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Perfect for Birthdays & Celebrations
        </h2>
        <p>Looking for <span className="fw-semibold">healthy birthday cakes in Chennai, T Nagar?</span></p>
        <p>Our <span className="fw-semibold">maida-free cakes</span> are ideal for:
        </p>
        <ul>
          <li>Kids’ birthdays</li>
          <li>Family celebrations</li>
          <li>Office events</li>
          <li>Health-focused gifting</li>
        </ul>
        <p>We customize cakes while keeping them <span className="fw-semibold">healthy, whole wheat, and preservative-free.</span></p>

        <div className="my-4">
          <button
            className="wheatbakes-btn-light"
            onClick={() => handleClickButton("https://wheatbakes.com/contact")}
          >
            Contact Us for Custom Orders
          </button>
        </div>
      </section>

      {/* DELIVERY */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Maida-Free Cakes Delivery in Chennai (Including T. Nagar)
        </h2>
        <p>We offer fast and reliable <span className="fw-semibold">maida-free cakes delivery </span>across Chennai.</p>
        <p><span className="fw-semibold">Delivery details </span></p>
        <ul>
          <li>Freshly baked to order</li>
          <li>Same-day / next-day delivery</li>
          <li>Service available in <span className="fw-semibold">T. Nagar</span>, Nungambakkam, Kodambakkam, Adyar & nearby areas</li>
          <li>Safe and hygienic packaging</li>
        </ul>

        <button
          className="wheatbakes-btn"
          onClick={() => handleClickButton("https://wheatbakes.com/menu")}
        >
          Order Online
        </button>
      </section>

      {/* WHY WHEATBAKES */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-3">
          Why WheatBakes Is Chennai’s Trusted Maida-Free Bakery
        </h2>
        <Row className="g-4">
                  {[
                    {
                      title: "100% Maida-Free Promise",
                      text: "No refined flour in any product.",
                    },
                    {
                      title: "Natural & Clean Baking",
                      text: "A true no-preservatives bakery",
                    },
                    {
                      title: "Health-Focused Recipes",
                      text: "Designed for daily consumption, not occasional guilt.",
                    },
                    {
                      title: "Fresh, Local & Reliable",
                      text: "Baked fresh in Chennai for Chennai customers.",
                    }
                  ].map((item, idx) => (
                    <Col md={4} key={idx}>
                      <Card className="h-100 shadow-sm">
                        <Card.Body>
                          <h5 className="fw-bold green-text"><span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span> {item.title}</h5>
                          <p className="mb-0">{item.text}</p>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
      </section>

      {/* FAQ */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 text-center">
          Frequently Asked Questions
        </h2>
        
        <div className="wheatbakes-accordian-container dark-text">
                    <Accordion
                      activeKey={activeKey}
                      onSelect={(key) => setActiveKey(key)}
                    >
                      {accordionData.map((item, index) => (
                        <Accordion.Item
                          key={index}
                          eventKey={String(index)}
                          className={
                            activeKey === String(index) ? "accordion-item-active" : ""
                          }
                        >
                          <Accordion.Header>{item.title}</Accordion.Header>
                          <Accordion.Body>{item.content}</Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </div>
      </section>

      {/* FINAL CTA */}
      <section className="text-center py-5 bg-light rounded">
        <h2 className="fw-bold mb-3 text-bold-600">
          Order Maida-Free Cakes Online
        </h2>
        <p className="text-align-center">
          Enjoy delicious cakes without refined flour or chemicals. Order
          maida-free cakes online from WheatBakes today.
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <button
            className="wheatbakes-btn"
            onClick={() => handleClickButton("https://wheatbakes.com/menu")}
          >
            Order Now
          </button>
          <button
            className="wheatbakes-btn-light"
            onClick={() => handleClickButton("https://wheatbakes.com/contact")}
          >
            Contact Page
          </button>
        </div>
      </section>

    </Container>
    </>
  );
}

export default MaidaFreeCakes;
